import React, {useState} from "react";
import Dialog from "@mui/material/Dialog";
import {AppCard, AppConfirmDialog, AppSpacer} from "../../components/ui";
import {t} from "../../utilities/TranslationUtils";
import ClientInfoDisplay from "./Components/ClientInfoDisplay";
import CopyClientInfoButton from "./Components/CopyClientInfoButton";
import {AppButton} from "../../components/form";

const SecretDisplayDialog = (props: {
  id: string;
  name: string;
  secret: string;
  isDialogOpened: boolean;
  onClose: () => void;
}) => {
  const [isConfirmCopyOpen, setIsConfirmCopyOpen] = useState(false)
  return (
    <Dialog
      maxWidth={'sm'}
      fullWidth
      className={`secret-display-dialog ${props.isDialogOpened ? 'open' : ''}`}
      open={props.isDialogOpened}
      onClose={props.onClose}
      data-test='secret-dialog'
    >
      <AppCard title={t('clients.secret')}>
        <AppConfirmDialog
          title={t('clients.copyConfirmationTitle')}
          message={t('clients.copyConfirmationText')}
          cancelLabel={t('common.cancel')}
          confirmLabel={t('common.yes')}
          isDialogOpen={isConfirmCopyOpen}
          onConfirm={() => {
            setIsConfirmCopyOpen(false)
            props.onClose()
          }}
          isLoading={false}
          onCancel={() => setIsConfirmCopyOpen(false)}
        />
        <ClientInfoDisplay
          id={props.id}
          secret={props.secret}
          name={props.name}
        />
        <footer className='pt-3 mt-4 border-top d-flex align-items-center justify-content-end'>
          <CopyClientInfoButton
            id={props.id}
            secret={props.secret}
          />
          <AppSpacer space='5px' isHorizontal={true}/>
          <AppButton
            variant='primary'
            onClick={() => setIsConfirmCopyOpen(true)}
            data-test='secret-dialog-close-button'
          >
            {t('common.close')}
          </AppButton>
        </footer>
      </AppCard>
    </Dialog>
  );
};

export default SecretDisplayDialog;